import { useState } from "react";

/**
 * FIX-001 (complete customer Manual). Non-technical, first-time-customer
 * documentation for the currently-live product only.
 *
 * Five-image Persona onboarding (2026-09-12): rewritten to match the
 * current flow — Create Persona is display-name-only (no internal key to
 * invent), the canonical COMPLETE reference set is the fixed Phota
 * training target of exactly 5 (`CANONICAL_COMPLETE_REFERENCE_SET`,
 * shared by the Create screen's copy and the Reference Upload screen's
 * cap; lowered from 50 the same day, based on a real controlled test —
 * see `train-persona-phota-profile.ts`'s own doc comment for the
 * evidence, never described to the customer here), training starts
 * automatically at 5/5, and Generate becomes available only once the
 * Phota Profile is both trained AND has cleared a short "Preparing"
 * period after training completes. `CreateTab.tsx` selects strictly on
 * `photaReadinessState === "ready"` — a partially-uploaded or still-
 * Training/Preparing Persona is never selectable in Create, so this
 * Manual never claims otherwise (the older "technically usable after a
 * first couple of images" wording described pre-fix behavior and has
 * been removed).
 *
 * FIX-011 (Recreate / a second provider) is explicitly NOT described
 * anywhere below — this Manual documents only the one currently-live
 * generation path (Persona Swap), matching what a real account can
 * actually do today.
 *
 * Nothing below names a tenant id, persona id, artifact UUID, storage
 * path, API key, provider/model name, or the word "propagation" — every
 * reference is to the customer-visible product surface only (the same
 * tab/section names the rest of GENERATE already uses).
 *
 * FIX-007 (2026-09-13): restructured into two clearly separate,
 * self-contained guides — "Create a Persona" and "Create a Persona Swap
 * Video" — so a reader immediately understands these are two distinct
 * processes (preparing a Persona vs. generating a video with one),
 * rather than one mixed explanation. No underlying Persona, Training,
 * Preparing, Gate, or Persona Swap generation behavior changed — this is
 * a documentation-accuracy and structure fix only. The second guide's
 * step 1 was also expanded to mention Visual Modifications and the
 * confirmation summary, both of which already exist on the live Create
 * screen (`CreateTab.tsx`) but were previously undocumented here.
 *
 * FIX-007 follow-up (2026-09-13, landing-screen navigation): the two
 * guides are no longer both rendered on one long page. The landing
 * screen shows only two selection buttons; choosing one shows ONLY that
 * guide's content, never both at once. Also makes the Training ->
 * Preparing -> Ready readiness flow fully explicit in the Create a
 * Persona guide, with the exact required wording for the ~15 minute
 * Preparing window (never merely "a short period"). Navigation/wording
 * only — no underlying Persona or Persona Swap workflow changed.
 *
 * Image Creation Workflow guide (2026-09-19): a third guide, in the same pattern, explaining the IMAGE flow that already exists (persona,
 * source image, number of images, REVIEW, the final decision, HISTORY, Bundles and Download all, and the Bundle list limit). Documentation
 * only - no Image behavior changed.
 *
 * 2026-09-28 content refresh (documentation/UX only — no backend, logic or workflow changed):
 *  - Gate 1 now explicitly covers the two real steps that run BEFORE VIDEO STUDIO creates the look image: choosing the source frame
 *    yourself (a picker of candidate frames opens automatically; it is no longer picked for you), and — only when that frame shows more
 *    than one person — choosing which person your Persona replaces.
 *  - Image Creation now lists Content Mode (SFW / SPICY / NSFW) and Requested changes (clothing color / pendant / glasses) among the real,
 *    already-live fields on the Create screen, in their actual on-screen order.
 *  - A new short "How approval works" note states the standing product rule plainly: a real result is never hidden by an automatic check —
 *    automatic findings are advisory notes only, and the human always makes the actual approve/reject decision.
 *  - The Dashboard row in "Where to look" now describes the current compact single-row status bar (click any item for its full detail),
 *    replacing the old "cards" description.
 *  - "Where to look" > Reviews now names Gate 3 alongside Gate 1 and Gate 2 — it already runs in the same Reviews area and was missing here.
 *  - Recreate / FIX-011 remains entirely absent — still not live in production.
 *
 * FIX-053 section A (2026-10-03, documentation only - no behavior changed): a fourth guide, "Research & Repurpose Reels", for the REEL area of Create; the intro
 * and "Where to look > Create" now name VIDEO | IMAGE | REEL. Customer wording only: no provider / system names, ids, storage paths, API or migration terms, and the
 * saved result is always called an "Approved Reel". RE is mentioned only as "not connected yet".
 *
 * FIX-011 closure follow-up (2026-10-17, documentation only - no behavior changed): a fifth guide, "Recreate a Video (RE)", describing the full RE path as it
 * works on screen (entry from Create or an Approved Reel, analysis, the two approvals, proposals, Get JSON, video creation, QC in Reviews, reuse with another
 * Persona). Create is now described as VIDEO | IMAGE | REEL | RE, and the Reel guide says RE is available for Approved Reels (Get JSON for Approved Reels is still coming soon).
 *
 * FIX-066 MANUAL item (owner t1061u, 2026-10-24): one paragraph in the Image guide, "3. Processing and results", describing the new Stop request button
 * and its confirmation exactly as labelled on screen. Customer wording only (no providers, no costs).
 *
 * FIX-062 MANUAL item (owner t535u, 2026-10-22, documentation only - no behavior changed): a sixth guide, "Find Reels with Deep Research", additive; the five
 * guides above and every other section are unchanged. Every label is the one on the live screen (CreateEntry DEEP RESEARCH card, DeepResearchTab /
 * DeepResearchAccounts / DeepResearchSelection, ReProject "Analyze"). The DEEP RESEARCH card is shown to every user who sees Create (not gated),
 * so this guide is too; running the searches needs an admin, as the screen says. Not described because it does not exist: a "Used" badge (the real marker is
 * "Sent to RP" / "Sent to RE") and a cost estimate before Pull or Pre-screen (only Add accounts and the US check show one).
 * Owner t537u (2026-10-22): excluded Reels are no longer shown in the Recommendation table, so step 3 now says they are left out.
 * Owner t546u (2026-10-22): only Reels known to be 30 s or shorter enter the US check, shortlist, table and handoff; step 3 says so.
 * Owner t554u (2026-10-22): the shortlist is ordered by US score first, then shares per 1K views; the Shortlist step says so.
 *
 * Auto-production guide (owner t858u + t859u, 2026-10-23, documentation only - no behavior changed): a seventh guide, "Auto-production", for the
 * DR -> RE auto-production that went live on 2026-10-23 (daily run 06:30 Israel time, catch-up until 12:00, top 2 of the IMPORTANT list's
 * Recommendation table with the RE-fit Reels first, 3 options x 2 personas, automatic Review / Final Review, one retry, daily limits, the two
 * owner-only buttons, the produced-once rule, the Drive DAILY / "הועלה" folders, the run card with Stop). Plain words for a non-engineer:
 * no setting names, addresses, code terms or ids. Not described because the screen does not have it: a pause / resume button and a list of past
 * runs. The RE and Deep Research guides each get one pointer line; nothing else changed.
 * ORIGIN fallback (owner 2026-10-23 19:19 / t869u): "Which Reels it picks" and the DR button paragraph describe the order IMPORTANT (RE fit) -> ORIGIN
 * (RE fit, latest results up to 3 days old) -> IMPORTANT next in line, and the "from ORIGIN" mark in the confirm window.
 * Owner t872u (2026-10-23): the Manual is a public guide - no account specifics in this guide (no Persona names, accessories or Drive folder
 * names, no owner-only phrasing): "your lead Persona and your second Persona", "your Google Drive folders".
 * Owner t873u (2026-10-23): a general public guide - no per-account settings either: the start time, the Deep Research schedule, the list names and
 * the backup list's interval / age, the daily video / spending limits and the button-press limit are configurable, so they are described in words.
 * Fixed product rules keep their numbers: 2 Reels per run, 3 versions, 6 per Persona (12 per run), one retry, score under 4, 30 seconds, 6 videos
 * from the RE button, 3 same failures / 2 failed mornings for the automatic pause; the midday cutoff is fixed and is said as "midday".
 * Owner t874u (2026-10-23): no costs and no provider names anywhere in this guide (the daily spending limit and the estimated cost in the confirm
 * windows are not described; Google Drive stays: it is the customer's own storage destination).
 * Owner t876u (2026-10-23): the same rule for the WHOLE guide; the matching on-screen labels were renamed so the guide matches the screen
 * ("Create video", "Analyze", "Preview"). The app's own confirm windows still show their estimates - only this public guide is restricted.
 */
type ManualGuide = "persona" | "persona-swap" | "image" | "reel" | "re" | "deep-research" | "auto-production";

export function ManualTab() {
  const [selectedGuide, setSelectedGuide] = useState<ManualGuide | null>(null);

  return (
    <div>
      <div className="card">
        <h2>Manual</h2>
        <p className="muted">
          A plain-language guide to setting up your model, creating your first video or image, and researching Reels for your Persona. Nothing here requires any technical
          background — if a step below doesn't match what you see on screen, it's safe to assume the on-screen version is
          current.
        </p>
      </div>

      <div className="card">
        <h3>Your private workspace</h3>
        <p>
          Everything you upload and create — your Persona, your reference photos, your source videos, and every video you
          generate — belongs to your own account's workspace. Other customers can never see, use, or reuse your models or
          media, and you can never see theirs.
        </p>
        <p className="muted">
          Some areas of Generate may be unavailable until your account meets a prerequisite (for example, verifying your
          email, or setting up a Persona) — see your Dashboard status bar and click an item to see what's outstanding. A step being
          temporarily blocked is different from your account being inaccessible: you can always sign in, check your
          Dashboard and Account pages, and see your History, even while a specific action is paused.
        </p>
      </div>

      <div className="card">
        <h3>How approval works</h3>
        <p>
          Whenever there's a real result to look at, <strong>you</strong> decide if it's good enough to approve. Automatic checks only
          add notes or warnings for you to consider — they never hide a real result or decide for you.
        </p>
      </div>

      {selectedGuide === null && (
        <div className="card">
          <h3>Choose a guide</h3>
          <p className="muted">Choose which guide you'd like to read.</p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <button onClick={() => setSelectedGuide("persona")}>Create a Persona</button>
            <button onClick={() => setSelectedGuide("persona-swap")}>Create a Persona Swap Video</button>
            <button onClick={() => setSelectedGuide("image")}>Image Creation Workflow</button>
            <button onClick={() => setSelectedGuide("reel")}>Research &amp; Repurpose Reels</button>
            <button onClick={() => setSelectedGuide("re")}>Recreate a Video (RE)</button>
            <button onClick={() => setSelectedGuide("deep-research")}>Find Reels with Deep Research</button>
            <button onClick={() => setSelectedGuide("auto-production")}>Auto-production</button>
          </div>
        </div>
      )}

      {selectedGuide === "persona" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Create a Persona</h3>
          <p>
            A <strong>Persona</strong> is your model — the identity Generate uses to create videos that look like a specific
            person.
          </p>
          <p>To create a new Persona, upload 5 clear photos of the same person.</p>
          <p>For the best identity match, use five different useful views:</p>
          <ol style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              <strong>Front</strong> — looking directly at the camera.
            </li>
            <li>
              <strong>Left 3/4</strong> — face slightly turned left.
            </li>
            <li>
              <strong>Right 3/4</strong> — face slightly turned right.
            </li>
            <li>
              <strong>Side / Profile</strong> — a stronger side view showing the shape of the face.
            </li>
            <li>
              <strong>Face + Hair</strong> — a clear photo showing the face, hairstyle and hairline well.
            </li>
          </ol>

          <h4>Photo tips</h4>
          <p>Use photos that are:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>clear and sharp;</li>
            <li>well lit;</li>
            <li>of the same person;</li>
            <li>showing the face clearly;</li>
            <li>taken from different useful angles.</li>
          </ul>
          <p>Avoid:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>blurry photos;</li>
            <li>sunglasses;</li>
            <li>heavy beauty filters;</li>
            <li>extreme shadows;</li>
            <li>objects covering the face;</li>
            <li>five nearly identical photos from the same angle.</li>
          </ul>
          <p className="muted">Five good, varied photos are better than many similar photos.</p>

          <ol style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>Open the <strong>Personas</strong> tab and create a Persona — just give it a display name.</li>
            <li>You'll be taken to the Upload screen for that Persona. Training starts automatically once all 5 photos are uploaded.</li>
            <li>
              The Persona is not selectable in Create until it becomes fully ready — see the readiness status shown on the
              Upload screen.
            </li>
          </ol>

          <h4>What happens next?</h4>
          <p className="muted">
            <strong>5 images → Training → Preparing for approximately 15 minutes → Ready</strong>
          </p>
          <p>After you upload the five photos:</p>
          <ol style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>VIDEO STUDIO creates your Persona.</li>
            <li>The Persona enters <strong>Training</strong>.</li>
            <li>
              When training finishes, the Persona enters <strong>Preparing</strong> for approximately 15 minutes. During
              this time, it is not yet available for video creation.
            </li>
            <li>
              Once Preparing is complete, its status becomes <strong>Ready</strong>. You can then select that Persona when
              creating a video.
            </li>
          </ol>
          <p className="muted">During Training or Preparing, you cannot Generate with that Persona yet.</p>
        </div>
      )}

      {selectedGuide === "persona-swap" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Create a Persona Swap Video</h3>

          <h4>1. Choose your Persona, source video and options</h4>
          <p>Choose the Persona you want to use.</p>
          <p>For the source video, you can either:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>upload a new video; or</li>
            <li>
              choose <strong>Use a previous upload</strong> to reuse a video you uploaded before.
            </li>
          </ul>
          <p>Then choose the Content Mode:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              <strong>SFW</strong> — standard safe content
            </li>
            <li>
              <strong>SPICY</strong> — more suggestive content
            </li>
            <li>
              <strong>NSFW</strong> — explicit adult content
            </li>
          </ul>
          <p>Then choose the video length:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>Up to 15 sec</li>
            <li>Up to 30 sec</li>
          </ul>
          <p>
            Optionally, choose any <strong>Visual Modifications</strong> — for example a clothing color change, or an
            available accessory such as a pendant or glasses.
          </p>
          <p className="muted">VIDEO STUDIO automatically uses the appropriate supported generation setup based on these choices.</p>
          <p>Before anything is generated, you'll see a summary of your choices to review — confirm it to begin.</p>

          <h4>2. Gate 1 — Check the look</h4>
          <p>Right after you submit, choose the source frame yourself: VIDEO STUDIO shows you a set of candidate frames from your video — click one to preview it, then confirm your choice.</p>
          <p className="muted">
            If that frame shows more than one person, you'll then click which person your Persona should replace — everyone
            else in the frame stays exactly as they are.
          </p>
          <p>
            VIDEO STUDIO creates an image showing how your Persona will look in the video, including any outfit or accessory
            changes you requested.
          </p>
          <p>Check the image and approve it when the look is right.</p>

          <h4>3. Gate 2 — Check the video</h4>
          <p>VIDEO STUDIO creates the video with your selected Persona while keeping the original movement, timing and scene.</p>
          <p>The system also checks that the result matches the look you approved.</p>
          <p>Watch the video and approve it when it looks right.</p>

          <h4>4. Final preparation</h4>
          <p>
            If the video contains speech, VIDEO STUDIO automatically handles the transcription, English translation and
            subtitles when needed.
          </p>
          <p>Quality is automatically upgraded to 1080p.</p>

          <h4>5. Gate 3 — Final approval</h4>
          <p>Watch the finished video.</p>
          <p>If everything looks and sounds right, approve it.</p>
          <p>After final approval, the video is saved in History.</p>
        </div>
      )}

      {selectedGuide === "image" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Image Creation Workflow</h3>
          <p>
            Image creation makes a set of new pictures of your Persona in the same scene as one image you provide. Each set is
            called an <strong>Image request</strong>, and it can contain from 1 to 15 images.
          </p>

          <h4>1. Select your Persona</h4>
          <p>First choose the Persona (your model) that the images will be created with.</p>
          <p className="muted">Only Personas that are ready to generate appear in the list.</p>

          <h4>2. Create an Image request</h4>
          <p>
            Open <strong>Create</strong> and choose <strong>IMAGE</strong>. Then:
          </p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              choose the Content Mode: <strong>SFW</strong>, <strong>SPICY</strong> or <strong>NSFW</strong> — one is required, and it
              applies to the whole request;
            </li>
            <li>
              upload one <strong>source image</strong> (JPEG or PNG) — it sets the scene, and your Persona replaces the person in
              it;
            </li>
            <li>choose your Persona;</li>
            <li>choose the number of images you want, from 1 to 15;</li>
            <li>
              optionally, choose any <strong>Requested changes</strong> — for example a clothing color change, or an available
              accessory such as a pendant or glasses; whatever you tick is applied automatically to every image once it's
              generated, and you are not asked again;
            </li>
            <li>check the details shown on the screen before you confirm.</li>
          </ul>
          <p>
            Click <strong>Generate</strong> to submit the request. Your request is saved and processed by the system — you can
            close the page and come back later.
          </p>

          <h4>3. Processing and results</h4>
          <p>
            When you open the request, each image has its own status — for example Generating, Ready for review, or Could not be
            produced — and the page tells you how many images were delivered.
          </p>
          <p>When the images are ready you can look at each one, and download any single image.</p>
          <p className="muted">
            If an image could not be produced, you may be able to retry it before you make your final decision (depending on your
            permissions). A retry is one extra attempt.
          </p>
          <p>
            While a request is still being generated you can click <strong>Stop request</strong> and confirm with{" "}
            <strong>Yes, stop request</strong> (depending on your permissions). No new images are started after that. An image that is
            already being made finishes, but it is not delivered. Images already delivered are kept, and you can then approve or reject
            the request as usual. A stopped request cannot be restarted or retried — create a new request instead.
          </p>

          <h4>4. REVIEW and approval</h4>
          <p>
            Your Image requests are reviewed in <strong>Reviews</strong>, under <strong>Image requests</strong> — one item for each
            request, however many images it has. The request stays there while it is being generated and until you make your
            final decision.
          </p>
          <p>
            Open the request to see all of its images. You can approve or reject individual images, and then approve or reject
            the whole request. What you can do depends on your permissions — people who can only view can look at the images but
            cannot approve or reject them.
          </p>
          <p>A request that produced no images can only be rejected.</p>
          <p>
            Your final decision (<strong>Approved</strong> or <strong>Rejected</strong>) moves the request to History. It is
            final.
          </p>

          <h4>5. History</h4>
          <p>
            Once you have made your final decision, the Image request appears in <strong>History</strong>, in the same list as your
            videos, marked <strong>IMAGE</strong> with its result (Approved or Rejected).
          </p>
          <p>Open it to see:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>the generated images, each with its own Download;</li>
            <li>the final result;</li>
            <li>the Bundles created from that request.</li>
          </ul>

          <h4>6. Bundles</h4>
          <p>
            A <strong>Bundle</strong> groups images you choose from one Image request. Bundles are optional — nothing is bundled
            automatically.
          </p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              To create one, open the request, tick <strong>Select for Bundle</strong> on the images you want, and click{" "}
              <strong>Create Bundle</strong>. A Bundle can only contain images from the same request, and only images you have
              approved.
            </li>
            <li>
              Click <strong>Download all</strong> on a Bundle to download all of its images together as one ZIP file.
            </li>
            <li>
              You can see a request's Bundles in its History page.
            </li>
          </ul>

          <h4>Note about the Bundle list</h4>
          <p className="muted">
            Bundles are never deleted automatically — the system keeps every Bundle you create. A request's History page lists it
            from the 100 most recent Bundles. Older Bundles are still stored, but they may not appear there.
          </p>

          <h4>7. Publish to Telegram (administrator only)</h4>
          <p>
            Approved images can be posted to the Telegram channel connected to the request. The channel is chosen automatically —
            you never pick or type it.
          </p>
          <ul>
            <li>
              Open the request and click <strong>Publish approved images to Telegram</strong> (or select images first to publish only
              those). A Bundle has its own <strong>Publish to Telegram</strong> button.
            </li>
            <li>
              A preview opens with the images. Write the caption and click <strong>Save caption</strong>. A caption is required. Links, handles and promotional text are not allowed.
            </li>
            <li>
              Nothing is posted until you click <strong>Publish now</strong>. Up to 10 images go out as one album; more are split into
              two posts.
            </li>
            <li>
              Images that are already in the channel are marked <strong>Already published</strong>. Posting them again needs an explicit
              confirmation.
            </li>
            <li>
              If the result is <strong>Unclear</strong>, check the channel and choose what happened. The system never re-sends on its
              own.
            </li>
            <li>Each channel gets a limited number of posts per day. All posts and their links are listed under Telegram posts.</li>
            <li>
              An optional daily automation can prepare and post one image per channel per day. It is off until the administrator turns
              it on under Telegram posts, and it only posts images that passed every check.
            </li>
          </ul>
        </div>
      )}

      {selectedGuide === "reel" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Research &amp; Repurpose Reels</h3>
          <p>
            Research helps you find Instagram Reels that performed unusually well for their original creator, so you can decide which ones are worth
            repurposing with your own Persona.
          </p>

          <h4>1. Choose your Persona</h4>
          <p>
            Open <strong>Create</strong>, choose <strong>REEL</strong>, and select the Persona you are researching for. Each Persona has its own
            Creator Bank — the creators you research for one Persona are never mixed with another's.
          </p>
          <p className="muted">The person in the original Reel never replaces the Persona you selected.</p>

          <h4>2. Add creators</h4>
          <p>
            Add the Instagram creators you want to research. Emma OS prepares each creator for Research automatically — you don't need to open or set
            up anything outside Emma OS.
          </p>

          <h4>3. Run Research</h4>
          <p>
            Research starts only when you start it. Reels are measured by how well they performed for their original creator — not by how similar
            they are to your Persona, and not by how easy they would be to produce. The strongest Reels are shown together in one list.
          </p>

          <h4>4. Content Analysis</h4>
          <p>Interesting Reels can be analyzed. The analysis shows two separate parts:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              <strong>Facts</strong> — information taken from the collected data;
            </li>
            <li>
              <strong>AI interpretation</strong> — an AI's reading of the Reel.
            </li>
          </ul>
          <p className="muted">
            The AI interpretation is not a fact, and it is never an automatic decision to produce anything.
          </p>

          <h4>5. Review</h4>
          <p>
            For each Reel you can see the collected information and its thumbnail, and you make one of two decisions: <strong>Approve for Use</strong>{" "}
            or <strong>Reject</strong>. <strong>Reject is final.</strong>
          </p>

          <h4>6. Approved Reels</h4>
          <p>
            A Reel you approve is saved as an <strong>Approved Reel</strong>, with all the information collected for it. Approving a Reel does not
            start creating a video.
          </p>

          <h4>7. Repurpose (RP)</h4>
          <p>
            Repurpose uses the existing video process, and you start it yourself. It always uses the Persona you selected — never the person in the
            original Reel.
          </p>
          <p>
            <strong>Recreate with RE</strong> is also available for an Approved Reel — it opens the RE guide's flow with that Reel's video already
            selected. <strong>Get JSON</strong> for Approved Reels is shown but is coming soon.
          </p>

          <h4>Saved videos for Research</h4>
          <p>
            Emma OS keeps up to <strong>20</strong> source MP4 videos for each Persona. When that limit is exceeded, older source MP4 files may be
            removed. The Research data, the analysis, your Review decision, the Approved Reel and its thumbnail all stay saved.
          </p>
          <p className="muted">
            If a source MP4 has already been removed, Repurpose cannot start from that file, and it is not fetched again automatically.
          </p>
        </div>
      )}

      {selectedGuide === "re" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Recreate a Video (RE)</h3>
          <p>
            RE studies a successful source video and helps you create a <strong>new</strong> video with your Persona in the same spirit — a
            recreation, not a copy of the original. You approve the analysis, choose and adjust the ideas you like, approve each one, and only then
            is a video created.
          </p>

          <h4>1. Open RE</h4>
          <p>
            Open <strong>Create</strong> and choose <strong>RE</strong>. You can also start from an Approved Reel: open it under{" "}
            <strong>REEL</strong> and click <strong>Recreate with RE</strong>.
          </p>
          <p className="muted">Your RE projects are saved. Open <strong>My RE projects</strong> any time to continue one.</p>

          <h4>2. Choose your Persona and source video</h4>
          <p>Choose the Persona the new video is for. Then choose the source video:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>upload a new video, or choose one of your previous uploads; or</li>
            <li>
              if you came from an Approved Reel, click <strong>Use this Reel's video</strong>.
            </li>
          </ul>
          <p className="muted">The source video can be at most 30 seconds long. Click <strong>Start analysis</strong> when you are ready.</p>

          <h4>3. The analysis</h4>
          <p>
            The source video is analyzed from start to finish — what happens and in what order, the people, actions, expressions, camera, speech, sound,
            outfit and setting. This takes a few minutes, and the page updates by itself. You see the source video next to the full analysis.
          </p>

          <h4>4. Check the analysis and approve it (first approval)</h4>
          <p>
            Check the analysis against the video. If something is wrong, describe it and click <strong>Request correction</strong> — a new version of the
            analysis is made and every earlier version is kept. When it is right, click <strong>Approve this analysis</strong>.
          </p>
          <p className="muted">An approved analysis is locked and cannot be changed. Proposals are only offered after this approval.</p>

          <h4>5. Three proposals — and more on request</h4>
          <p>
            Click <strong>Get 3 proposals</strong>. You receive three different ideas for recreating the video. Each includes the scene, outfit,
            environment, dialogue, voice, music and sound effects. If you want more ideas, click <strong>Request more proposals</strong> — each request adds
            a new group, and all groups stay visible.
          </p>

          <h4>6. Choose the proposals to produce</h4>
          <p>
            Click <strong>Select for production</strong> on the proposals you want. You can choose from any group, as many as you want.
          </p>

          <h4>7. Adjust scene, outfit and environment</h4>
          <p>
            As soon as you click <strong>Select for production</strong>, three boxes appear right under that proposal, above the approve button: the{" "}
            <strong>scene</strong>, the <strong>outfit</strong> and the <strong>environment</strong>. Change what you want, then click{" "}
            <strong>Save adjustments</strong>. Each save is a new version. The dialogue, voice, music and effects stay as proposed.
          </p>
          <p className="muted">These boxes are only there before you approve. An approved proposal is locked, so make your changes first.</p>

          <h4>8. Approve each proposal (second approval)</h4>
          <p>
            Click <strong>Approve this proposal</strong> and then confirm with <strong>Yes, approve</strong>, for each proposal you want to produce — every one separately. Approving locks that exact version,
            including your adjustments. The Persona needs a ready voice for this step; if it does not have one, you will be told.
          </p>
          <p className="muted">Approving does not create a video yet.</p>

          <h4>9. Get JSON</h4>
          <p>
            After at least one proposal is approved, <strong>Get JSON</strong> downloads the approved plan — the approved analysis and your approved
            proposals — as a file. It is an export only.
          </p>

          <h4>10. Create the video</h4>
          <p>
            On an approved proposal click <strong>Create video</strong>. You can choose the length (2 to 30 seconds) or leave it to follow the
            source video, then confirm. This creates the video, and it is created once for each approved proposal. Your Persona's photos and its
            voice are used for the new video.
          </p>
          <p className="muted">When the video exists, the proposal shows a link to it. While it is being created you can also follow it in <strong>History</strong>, under <strong>Active</strong> (status "generating").</p>

          <h4>11. Quality check in Reviews</h4>
          <p>
            The new video appears in <strong>Reviews</strong> like any other. Next to it, <strong>Quality check against the approved proposal</strong>{" "}
            compares the video with what you approved — identity, scenes, actions, expressions, dialogue, speakers, outfit, camera, duration, sound and
            technical quality. Each finding is <strong>MATCH</strong>, <strong>MISMATCH</strong> or <strong>UNRESOLVED</strong>, and each is marked as
            measured or as a model assessment.
          </p>
          <p className="muted">
            The quality check is advice only. It never holds a video back, and you decide whether to approve it. It may take a minute or two to appear.
          </p>

          <h4>12. Approve or reject, and what follows</h4>
          <p>
            Approve or reject the video in Reviews, as for any video. After approval it continues automatically through the upgrade to 1080p and the
            subtitles to <strong>Final Review</strong>, where you give the final approval. After that it is saved in <strong>History</strong>.
          </p>

          <h4>13. Save and reuse a plan</h4>
          <p>
            Every RE project is saved with its approved analysis and proposals. To use the same plan with another Persona, open the project and use{" "}
            <strong>Reuse this plan with another persona</strong>. A new project is created for that Persona — nothing is analyzed again and the original
            project stays as it is. Proposals you had selected come back as selected, and need approval again for the new Persona.
          </p>
          <p className="muted">
            Want it all done for you? After choosing a source video, the <strong>Auto-produce (both personas)</strong> button makes 6 videos in one go,
            with both Personas. See the <strong>Auto-production</strong> guide.
          </p>
        </div>
      )}

      {selectedGuide === "deep-research" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Find Reels with Deep Research</h3>
          <p>
            Deep Research looks through the Instagram accounts you track, finds the Reels that perform best with a US audience, checks which ones are a
            good fit for remaking with your Persona, and recommends the best ones. Nothing is produced until you send a Reel to production yourself.
          </p>

          <h4>It runs by itself every morning</h4>
          <p>
            When automatic research is turned on for your account, it runs every morning on the <strong>IMPORTANT</strong> list and every 3 days on the{" "}
            <strong>ORIGIN</strong> list. The recommendation table is usually ready when you come in. Above the table you can see which day's results it
            shows and when they were last updated — for example "Today's completed pre-screens of the IMPORTANT bank".
          </p>
          <p className="muted">Between runs, the latest results stay on screen.</p>

          <h4>1. Open Deep Research</h4>
          <p>
            Open <strong>Create</strong> and click the <strong>DEEP RESEARCH</strong> card.
          </p>

          <h4>2. Choose a list</h4>
          <p>
            Under <strong>Bank</strong>, choose <strong>IMPORTANT</strong> (the default) or <strong>ORIGIN</strong>. The two lists are always kept
            separate, and each has its own shortlist and its own recommendation table.
          </p>

          <h4>3. The recommendation table</h4>
          <p>
            The <strong>Recommendation</strong> table lists the Reels that went through the pre-screen. Up to 5 are marked <strong>recommended</strong>{" "}
            and up to 2 more are marked <strong>spare</strong>. The table is sorted by US score first, then by shares per 1K views, then by the pre-screen
            score.
          </p>
          <p className="muted">Reels with a red flag or a score under 4 are left out of the table.</p>
          <p className="muted">Only Reels of 30 seconds or less are included — in the table, the shortlist and the US check.</p>

          <h4>4. Watch the original</h4>
          <p>
            Click <strong>Watch on IG</strong> to open the original Reel on Instagram.
          </p>

          <h4>5. Pick the Reels you want</h4>
          <p>
            Tick <strong>pick</strong> next to each Reel you want to produce. The screen suggests 5, but there is no limit.
          </p>

          <h4>6. Choose RP or RE for each pick</h4>
          <p>
            Under <strong>Your picks: RP or RE</strong>, choose for each picked Reel:
          </p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              <strong>RP</strong> (Persona Swap) — your Persona replaces the person in the Reel. Choosing a Persona here is optional.
            </li>
            <li>
              <strong>RE</strong> (Recreate) — a new video is rebuilt from the Reel. You must choose a Persona.
            </li>
          </ul>

          <h4>7. Send to production</h4>
          <p>
            Click <strong>Send to RP</strong> or <strong>Send to RE</strong>. The system downloads the Reel's video and opens the regular screen with it
            already loaded. Nothing starts by itself.
          </p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              <strong>RP</strong>: <strong>Create</strong> &gt; <strong>VIDEO</strong> opens with the Reel as the source video (and your Persona, if you
              chose one). Continue as usual: frame choice, Gate 1, Gate 2 and the final approval.
            </li>
            <li>
              <strong>RE</strong>: a new RE project opens for the Reel. Click <strong>Analyze</strong> and continue as usual (see the RE guide).
            </li>
          </ul>

          <h4>Search yourself any time</h4>
          <p>You don't have to wait for the morning run. On the same screen you can run each step by hand:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              <strong>Add accounts</strong> — <strong>Preview</strong> shows what will be added first, then click <strong>Confirm</strong>.
            </li>
            <li>
              <strong>Pull new reels</strong> — click <strong>Pull</strong> to bring in the newest Reels of the tracked accounts.
            </li>
            <li>
              <strong>US check</strong> — <strong>Preview</strong> lists the Reels first, then <strong>Score</strong> checks them for
              US fit.
            </li>
            <li>
              <strong>Shortlist</strong> — Reels are listed with the highest US score first, then the most shares per 1K views. Tick 1 to 10
              Reels (the top 8 are ticked for you) and click <strong>Pre-screen</strong>. A Reel needs a US score before it can be pre-screened.
            </li>
          </ul>
          <p className="muted">
            Running these steps needs an admin. Each run appears under <strong>Jobs</strong>, and the tables refresh by themselves when it finishes.
          </p>

          <h4>Good to know</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              A Reel you have sent is marked <strong>Sent to RP</strong> or <strong>Sent to RE</strong> in the table, and it is not offered again in the
              shortlist.
            </li>
            <li>At most 3 Reels from the same creator are recommended.</li>
            <li>
              The <strong>Auto-produce top 3 (RE)</strong> button in the Recommendation card makes videos from the top 3 Reels for you. See the{" "}
              <strong>Auto-production</strong> guide.
            </li>
          </ul>
        </div>
      )}

      {selectedGuide === "auto-production" && (
        <div className="card">
          <button onClick={() => setSelectedGuide(null)}>← Back to guides</button>
          <h3>Auto-production</h3>
          <p>
            Auto-production makes RE videos for you from the best Reels that Deep Research found. It makes them with two of your Personas: your lead
            Persona and your second Persona. All approvals are done for you. The finished videos are saved in <strong>History</strong> and copied to
            your Google Drive folders.
          </p>
          <p className="muted">Auto-production works only when it is turned on for your account. If you don't see its buttons, it isn't turned on for you.</p>

          <h4>Every morning, by itself</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>Every morning, at the time set for your account, auto-production gets ready to start.</li>
            <li>It waits until your morning Deep Research run has finished its pre-screen of your main list. Then it starts.</li>
            <li>If the pre-screen still hasn't finished by midday, nothing is made that day. The day is recorded as skipped.</li>
            <li>It runs once a day. If a run you started with a button is still going, the morning run waits until it ends.</li>
          </ul>

          <h4>Which Reels it picks</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>It goes down the Recommendation table of your main list from the top: the highest US score first.</li>
            <li>It takes the first 3 Reels that the pre-screen found suitable for RE.</li>
            <li>
              If your main list doesn't have 3 of them, it looks next at your second (backup) list, which is checked less often. It takes that list's best
              Reels that are suitable for RE. The backup list's latest results are used only if they are recent.
            </li>
            <li>If there are still not enough, it takes the next Reels in line from your main list.</li>
            <li>It skips Reels with a red flag, a score under 4, Reels longer than 30 seconds, and Reels that were already made.</li>
            <li>If a Reel can't be made (for example, its analysis fails), the next Reel in line takes its place.</li>
          </ul>

          <h4>What it makes</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>3 versions of each Reel.</li>
            <li>
              The first and third Reels are made first with one of your two Personas, and the second Reel first with the other. Then the same 3 versions of each Reel
              are made with the other Persona too.
            </li>
            <li>So one run makes up to 18 videos: 9 with each Persona.</li>
          </ul>

          <h4>Approvals are automatic</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              You don't need to approve anything. Review and <strong>Final Review</strong> are approved for you, and each video goes through the 1080p
              upgrade and subtitles as usual.
            </li>
            <li>If a video fails, it is tried one more time. If the second try fails too, that video is skipped and marked as failed.</li>
          </ul>

          <h4>Limits</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>The morning run has a daily video limit set for your account. When it reaches the limit, it starts no more videos.</li>
            <li>
              The buttons have a daily limit on how many times they can be pressed (both buttons together). Button runs don't count toward the morning
              run's limits.
            </li>
            <li>Only one run goes at a time.</li>
          </ul>

          <h4>Start it yourself with a button</h4>
          <p>
            <strong>From Deep Research:</strong> open <strong>Create</strong> and click the <strong>DEEP RESEARCH</strong> card. In the{" "}
            <strong>Recommendation</strong> card, click <strong>Auto-produce top 3 (RE)</strong>. A window shows which 3 Reels will be made, which
            Persona goes first for each, and how many videos. Click <strong>OK</strong> to start. The button picks the Reels the
            same way as the morning run: first your main list, then your backup list if needed. A Reel taken from the backup list is marked in the window.
          </p>
          <p>
            <strong>From RE:</strong> open <strong>Create</strong> and choose <strong>RE</strong>. Choose a source video. Under{" "}
            <strong>Auto-produce (both personas)</strong>, choose which of your two Personas goes first (your lead Persona). Then click{" "}
            <strong>Auto-produce (both personas)</strong>. A window shows the number of videos (6: 3 versions with each Persona).
            Click <strong>OK</strong> to start.
          </p>
          <p className="muted">A button locks as soon as you click it, so a run can't be started twice by mistake.</p>

          <h4>When a button is grey</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>A run is already going.</li>
            <li>Auto-production is paused or switched off. A short note next to the button says so.</li>
            <li>The daily limit on button presses has been reached.</li>
            <li>
              On the RE screen only: this source video was already made (the screen says when), it is longer than 30 seconds, or you haven't chosen
              which Persona goes first yet.
            </li>
          </ul>

          <h4>A Reel is made only once</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              Once a video has been made from a Reel (with RE or RP), that Reel disappears for good from every list: the shortlist, the Recommendation
              table, the morning run and both buttons.
            </li>
            <li>A Reel you only sent, without making a video from it, stays available.</li>
          </ul>

          <h4>Google Drive</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>Every finished video is copied to your Google Drive, into that Persona's daily folder.</li>
            <li>
              Every morning, before the run, the earlier videos move from the daily folder to that Persona's "uploaded" folder. So the daily folder
              always holds only the newest videos.
            </li>
            <li>Only videos that auto-production put there are moved. Nothing is ever deleted, and your own files in those folders are not touched.</li>
            <li>If Google Drive can't be reached, the videos are still saved in History.</li>
          </ul>

          <h4>Follow a run and stop it</h4>
          <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
            <li>
              While a run is going, an <strong>Auto-production run</strong> card shows on the Deep Research and RE screens, with its status and a short
              summary. It updates by itself.
            </li>
            <li>
              Click <strong>Stop</strong> to stop the run. Nothing new starts. Videos that are already being made finish as usual and wait for you in
              Reviews.
            </li>
            <li>When the run ends, the card goes away. The finished videos are in History.</li>
            <li>
              Auto-production pauses by itself if the same problem happens 3 times in one run, or if two morning runs in a row fail. The buttons then
              show "Paused" and the reason. There is no button to turn it back on yet — ask to have it switched back on.
            </li>
          </ul>
        </div>
      )}

      <div className="card">
        <h3>Where to look</h3>
        <div className="kv">
          <dt>Dashboard</dt>
          <dd>
            A compact row of quick status items — account, usage, latest result, and more. Click any item to see its
            full detail.
          </dd>
          <dt>Create</dt>
          <dd>
            Choose <strong>VIDEO | IMAGE | REEL | RE</strong>. VIDEO and IMAGE start a new video or a new Image request: for a video, pick your Persona,
            source video, and any modifications; for images, upload a source image, pick your Persona, and choose how many images you want. REEL is where
            you research Reels for a Persona. RE recreates a source video as a new video with your Persona.
          </dd>
          <dt>Reviews</dt>
          <dd>
            Review generated results that are waiting on you: approve or reject videos at Gate 1, Gate 2 and Gate 3, and Image requests until you
            make your final decision.
          </dd>
          <dt>History</dt>
          <dd>
            Every video and upload you've ever created, including finished results and past attempts. Image requests you have approved or rejected
            also appear here, with their images and any Bundles created from them.
          </dd>
          <dt>Monitor</dt>
          <dd>A live view of anything currently processing for your account.</dd>
        </div>
      </div>
    </div>
  );
}
